import StaticPage, {
  getStaticPaths,
  getStaticProps,
} from "@/modules/static-page/StaticPage";

export { getStaticPaths, getStaticProps };
export default StaticPage;
